/*!
    * @product/scmp-sdk 1.1.39-hotfix.1
    * built by undefined
  */
import{i as t}from"./chunk-LJFPE7XX.js";var r=()=>{let{acquisition:{getPersonalizationByExperimentId:e,getVariantByExperimentId:i,uiTestingState:o}}=t();return{getPersonalizationByExperimentId:e,getVariantByExperimentId:i,uiTestingState:o}};export{r as a};
//# sourceMappingURL=chunk-QS2F257S.js.map
